<template>
  <div class="page">
    <dashboard-header></dashboard-header>
    
    <div class="content">
      <div class="container-fluid">
        <!-- Page title -->
        <div class="page-header">
          <div class="row align-items-center">
            <div class="col-auto">
              <h2 class="page-title" v-if="username">
                Welcome Back, {{username}}
              </h2>
            </div>
          </div>
        </div>
      
        <div class="row row-deck row-cards">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body text-left">
                <img src="static/quicklinks.jpg" alt="Tabler" style="float: right; border-radius: 50%; border: 1px blue solid;" width="200">
                <h2>Quick Links to Keep Track of Your Clients</h2>
                
                <router-link class="btn btn-primary" to="/client/new">Create a New Client</router-link>
                <router-link class="btn btn-primary" to="/tasks">Show My Tasks</router-link>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row row-deck row-cards">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body text-left">
                <h2>Your Tasks That Need Screenshots</h2><div>{{tasksPerPage}} Max. For More <router-link to="/tasks">Click Due Tasks Panel</router-link></div>
                
                <paged-api-table
                  v-bind:columns="taskColumns"
                  module="DueTasks"
                  default-sort="client ASC"
                  v-bind:custom-data-source="dueTaskApi"
                  v-bind:per-page="tasksPerPage">
                  </paged-api-table>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
  import DashboardHeader from "./DashboardHeader.vue";
  import DashboardFooter from "./DashboardFooter.vue";
  import PagedApiTable from "./PagedApiTable.vue";
  import AuthToken from "../api/authtoken.js";
  import WebLLCRESTApi from "../api/api.js";
  import { Usernames } from "../util/usernames.js";
  
  export default {
    async created() {
      //this.refreshInfo();
      //this.refreshTimer = setInterval(() => this.refreshInfo(), 15000);
      
      const apiUsers = new WebLLCRESTApi("Users", this.$router);
      this.users = apiUsers.getData(null, {
        order: ["firstName ASC", "lastName ASC"]
      });
      
      this.dueTaskApi = {
        getData: async (refreshPageCount, curPage, perPage, sortFilter, whereFilter) => {
          const api = new WebLLCRESTApi("Due-Tasks");
          
          const args = [
            { name: "order", value: sortFilter },
            { name: "viewuser", value: "me" }
          ];
          
          const res = await api.remoteMethod("view", args, true);
          const dataRaw = await res.json();
          const data = dataRaw.filter((task) => {
            return task.taskTypes.indexOf("Screenshot") != -1;
          });
          
          if(data.length > this.tasksPerPage) {
            const offset = curPage * perPage;
            const endOffset = (curPage + 1) * perPage;
            
            const dataSnippet = data.slice(offset, Math.min(endOffset, data.length));
            
            return {
              totalCount: this.tasksPerPage,
              data: dataSnippet
            };
          }
          else {
            return {
              totalCount: data.length,
              data: data
            };
          }
        }
      };
      
      const loggedInUser = AuthToken.getAuthObject();
      this.username = await (async () => {
        const users = await this.users;
        
        for(const user of users) {
          if(user.username == loggedInUser.username) {
            return user.firstName + " " + user.lastName;
          }
        }
        
        return loggedInUser.username;
      })();
    },
    
    beforeDestroy() {
      // cancel the timer
      //clearInterval(this.refreshTimer);
    },
    
    data() {
      return {
        users: null,
        username: null,
        dueTaskApi: null,
        
        jobInfo: {
          ready: 0,
          scheduled: 0,
          failed: 0
        },
        
        runningJobs: {
          runningJobs: 0,
          queuedProcesses: 0
        },
        
        taskColumns: [
          { key: "client", "text": "Client", type: "String", sort: true },
          { key: "campaign", "text": "Campaign", type: "String" },
          { key: "owner", "text": "Acct Manager", type: "String", sort: true, fnAsyncLoad: (item) => { return Usernames.getUserFullName(this.users, item.owner) } },
          { key: "authBasicUser", "text": "Assistant", type: "String", fnAsyncLoad: (item) => { return Usernames.showBasicAuthUsers(this.users, item) } },
          { key: "details", "text": "View Client", type: "Route", route: "/client/:id" },
        ],
        
        tasksPerPage: 10
      };
    },
    
    methods: {
      async refreshInfo() {
        const apiClients = new WebLLCRESTApi("Clients", this.$router);
        const apiJobs = new WebLLCRESTApi("Jobs");
        
        var jobInfo = await apiClients.remoteMethod("job-info");
        this.jobInfo = await jobInfo.json();
        
        var runningJobs = await apiJobs.remoteMethod("count");
        this.runningJobs = await runningJobs.json();
      }
    },
    
    components: {
      DashboardHeader,
      DashboardFooter,
      PagedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue